export interface SolicitacaoCadastroListItem {
  id: string;
  nome: string;
  dataNascimento: string;
  cpf: string;
  email: string;
  usuarioId: string;
  tenantId: string;
  pessoaAnalistaId: string | null;
  status: {
    id: StatusSolicitacaoCadastroEnum;
    nome: string;
    motivo: string;
    telefone: string;
  };
}

export interface SolicitacaoCadastroDetails {
  id: string;
  pessoa: {
    nome: string;
    dataNascimento: Date;
    cpf: string;
    imagemUrl: string;
    email: string;
    celular: string;
  };
  documentoImovel: string | null;
  documentoPessoal: string | null;
  createdAt: string;
  unidade: string;
  pessoaAnalistaId: string | null;
  logs: {
    createdAt: string;
    status: { id: string; nome: string };
    motivo: string;
    pessoa: {
      id: string;
      nome: string;
    };
  }[];

  statusId: StatusSolicitacaoCadastroEnum;
  statusNome: string;
  statusMotivo: string;
  statusResponsavel: string;
}

export enum StatusSolicitacaoCadastroEnum {
  Aprovado = "F276FEA2-122F-4A93-85C1-72B16F26E335",
  Rejeitado = "3A11AC1B-A394-4C21-B45C-9BE1A7678E4A",
  EmAnalise = "7F75F64E-ED76-4F17-94AD-F3466980CB8C",
  DisponivelParaAnalise = "7F75F64E-ED76-4F17-94AD-F3466980CB9C",
}
